import {
    getImageOriginal,
    getImageRegular,
    getMediaType,
    getShowMedia,
} from '../../../common/elements/utils/elementPropertyUtils';
import { RESIZEABLE_MEDIA } from '../../../common/links/richMediaConstants';
import { ImMNElement } from '../../../common/elements/elementModelTypes';

export const getIsLinkMediaVisible = (element: ImMNElement) => {
    if (!getShowMedia(element)) return false;

    const mediaType = getMediaType(element);
    const hasImageMedia = !!(getImageOriginal(element) || getImageRegular(element));

    // There's a bug where some links don't have a media type but do have an image
    return hasImageMedia && (RESIZEABLE_MEDIA.includes(mediaType) || !mediaType);
};

export const getIsLinkMediaHidden = (element: ImMNElement) => !getIsLinkMediaVisible(element);
